module.exports = __webpack_public_path__ + "static/media/1@2x.5ff03694.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_148/img/1@2x.png
// module id = 1422
// module chunks = 0